import React from "react";
import * as S from "./styles";
import {FormInputParams} from "./types";


export const FormInput = ({name, data, setValue, placeholder, isValid = true, hint}: FormInputParams) => {
    const handleChange = e => setValue(name, e.target.value);

    return (
        <div style={{marginBottom: '1rem'}}>
            <S.FormInput name={name}
                         value={data[name] || ''}
                         placeholder={placeholder}
                         onChange={handleChange}
                         isValid={isValid}
                         type={'text'}
            />
            <S.FormInputHint>{!isValid && hint ? hint : '\u00A0'}</S.FormInputHint>
        </div>
    );
}